module.exports = __webpack_public_path__ + "img/oneList3_new.baa115a1.png";